<div class="modal-content">
  <!-- Standard Message -->
  @if (!error) {
      <div class="modal-body pb-0 pt-3">
        <div class="row align-items-center mb-4 px-2">
          <div class="col-12 fs-5">
            @if (message) {
              <div>
                {{ message }}
              </div>
            }
          </div>
        </div>
      </div>

      <div class="modal-footer border-top-0 pt-0">
        <button
          type="button"
          class="btn modern-btn secondary-btn px-4"
          (click)="closeModal()"
        >
          OK
        </button>
      </div>
  }

  <!-- Error Modal -->
  @if (error) {
    <div>
      <div
        class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
      >
        <div class="modal-title text-danger">
          <h4 class="mb-0">
            <i class="fa-solid fa-triangle-exclamation me-2"></i> Error Message!
          </h4>
        </div>
        <button
          type="button"
          class="close-btn float-end"
          aria-label="Close"
          (click)="closeModal()"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="modal-body pb-0 pt-3">
        <div class="row align-items-center mb-4 px-2">
          <div class="col-12 fs-5 text-danger">
            {{ message }}
          </div>
        </div>
      </div>

      <div class="modal-footer border-top-0 pt-0">
        <button
          type="button"
          class="btn modern-btn secondary-btn px-4"
          (click)="closeModal()"
        >
          Close
        </button>
      </div>
    </div>
  }
</div>
